// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9953":"3f4802ca","17793":"3f4802ca"}[chunkId] + ".chunk.css";
};